import {
  FETCH_TRACKING_PAGE_FAILURE,
  FETCH_TRACKING_PAGE_SUCCESS,
} from 'constants/payment';
import type { Cashback } from 'models/cashBack';

type CashbackAction =
  | {
      type: typeof FETCH_TRACKING_PAGE_SUCCESS;
      payload: {
        cashback?: Cashback;
      };
    }
  | { type: typeof FETCH_TRACKING_PAGE_FAILURE };

export const cashback = (
  state: Cashback | Record<string, never> = {},
  action: CashbackAction,
) => {
  switch (action.type) {
    case FETCH_TRACKING_PAGE_SUCCESS:
      const { cashback: { agreedTransaction = {} } = {} } = action.payload;

      return {
        ...state,
        agreedTransaction: agreedTransaction,
      };
    case FETCH_TRACKING_PAGE_FAILURE:
      return {};
    default:
      return state;
  }
};
